/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Start: BridgeCommands.Command<
    Types.Gfn.Streaming.StartParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_START',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'Start',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Prepare: BridgeCommands.Command<
    Types.Gfn.Streaming.PrepareParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_PREPARE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'Prepare',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAuthInfo: BridgeCommands.Command<
    Types.Gfn.Streaming.SetAuthInfoParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_SET_AUTH_INFO',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetAuthInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAuthToken: BridgeCommands.Command<
    Types.Gfn.Streaming.SetAuthTokenParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_SET_AUTH_TOKEN',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetAuthToken',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetPrefetchedSettings: BridgeCommands.Command<
    Types.Gfn.Streaming.SessionConfiguration,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_SET_PREFETCHED_SETTINGS',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetPrefetchedSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Stop: BridgeCommands.Command<
    Types.Gfn.Streaming.StopParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_STOP',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'Stop',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Cleanup: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_CLEANUP',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'Cleanup',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetActiveSessions: BridgeCommands.Command<
    Types.Gfn.Streaming.GetActiveSessionsParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_GET_ACTIVE_SESSIONS',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetActiveSessions',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSessionInfo: BridgeCommands.Command<
    Types.Gfn.Streaming.GetSessionInfoParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_GET_SESSION_INFO',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetSessionInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Cancel: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_CANCEL',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'Cancel',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Resume: BridgeCommands.Command<
    Types.Gfn.Streaming.ResumeParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_RESUME',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'Resume',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PauseStreaming: BridgeCommands.Command<
    Types.Gfn.Streaming.PauseStreamingParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_PAUSE_STREAMING',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'PauseStreaming',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const UpdateRemoteConfig: BridgeCommands.Command<
    Types.Gfn.Streaming.UpdateRemoteConfigParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_UPDATE_REMOTE_CONFIG',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'UpdateRemoteConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterCallback: BridgeCommands.Command<
    {},
    Types.Gfn.Streaming.RegisterCallbackReturn
    > = {
    legacyCommand: 'QUERY_GFN_REGISTER_CALLBACK',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'RegisterCallback',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OpenOsr: BridgeCommands.Command<
    Types.Gfn.Streaming.OpenOsrParameters,
    string
    > = {
    legacyCommand: 'QUERY_WIN_OPEN_OSR',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'OpenOsr',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CloseOsr: BridgeCommands.Command<
    {},
    string
    > = {
    legacyCommand: 'QUERY_WIN_CLOSE_OSR',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'CloseOsr',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OsrRegisterCustomKeyPress: BridgeCommands.Command<
    Types.Gfn.Streaming.OsrRegisterCustomKeyPressParameters,
    string
    > = {
    legacyCommand: 'QUERY_OSR_REGISTER_KEYPRESS',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'OsrRegisterCustomKeyPress',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OsrUnregisterCustomKeyPress: BridgeCommands.Command<
    Types.Gfn.Streaming.OsrUnregisterCustomKeyPressParameters,
    string
    > = {
    legacyCommand: 'QUERY_OSR_UNREGISTER_KEYPRESS',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'OsrUnregisterCustomKeyPress',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OsrCheckKeyPressCombination: BridgeCommands.Command<
    Types.Gfn.Streaming.OsrCheckKeyPressCombinationParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_OSR_CHECK_KEYPRESS_COMBINATION',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'OsrCheckKeyPressCombination',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OsrRegisterKeyPressCallback: BridgeCommands.Command<
    Types.Gfn.Streaming.OsrRegisterKeyPressCallbackParameters,
    string
    > = {
    legacyCommand: 'QUERY_OSR_REGISTER_KEYPRESS_CALLBACK',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'OsrRegisterKeyPressCallback',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OsrSetOverlayResolution: BridgeCommands.Command<
    Types.Gfn.Streaming.OsrSetOverlayResolutionParameters,
    any
    > = {
    legacyCommand: 'QUERY_OSR_SET_OVERLAY_RESOLUTION',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'OsrSetOverlayResolution',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetStreamVolume: BridgeCommands.Command<
    {},
    number
    > = {
    legacyCommand: 'QUERY_GFN_GET_STREAM_VOLUME',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetStreamVolume',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetStreamStats: BridgeCommands.Command<
    {},
    Types.Gfn.Streaming.GetStreamStatsReturn
    > = {
    legacyCommand: 'QUERY_GFN_GET_STREAM_STATS',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetStreamStats',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetStreamVolume: BridgeCommands.Command<
    Types.Gfn.Streaming.SetStreamVolumeParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_SET_STREAM_VOLUME',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetStreamVolume',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetMagnificationFilter: BridgeCommands.Command<
    Types.Gfn.Streaming.SetMagnificationFilterParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_SET_MAG_FILTER',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetMagnificationFilter',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetMagnificationFilterSupport: BridgeCommands.Command<
    Types.Gfn.Streaming.GetMagnificationFilterSupportParameters,
    Types.Gfn.Streaming.GetMagnificationFilterSupportReturn
    > = {
    legacyCommand: 'QUERY_GFN_GET_MAG_FILTER_SUPPORT',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetMagnificationFilterSupport',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetMagnificationFilterSupportList: BridgeCommands.Command<
    Types.Gfn.Streaming.GetMagnificationFilterSupportListParameters,
    Types.Gfn.Streaming.GetMagnificationFilterSupportListReturn
    > = {
    legacyCommand: 'QUERY_GFN_GET_MAG_FILTER_SUPPORT_LIST',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetMagnificationFilterSupportList',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetMagnificationFilterSharpness: BridgeCommands.Command<
    Types.Gfn.Streaming.SetMagnificationFilterSharpnessParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_SET_MAG_FILTER_SHARPNESS',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetMagnificationFilterSharpness',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ToggleUserInput: BridgeCommands.Command<
    Types.Gfn.Streaming.ToggleUserInputParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'ToggleUserInput',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ToggleJoystickMouse: BridgeCommands.Command<
    Types.Gfn.Streaming.ToggleJoystickMouseParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_TOGGLE_JOYSTICK_MOUSE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'ToggleJoystickMouse',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetVirtualKeyboardState: BridgeCommands.Command<
    Types.Gfn.Streaming.SetVirtualKeyboardStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetVirtualKeyboardState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetVideoTransforms: BridgeCommands.Command<
    Types.Gfn.Streaming.SetVideoTransformsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetVideoTransforms',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ToggleStats: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_GFN_TOGGLE_INTERNAL_STATS',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'ToggleStats',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterGamepadChangedCallback: BridgeCommands.Command<
    {},
    Types.Gfn.Streaming.RegisterGamepadChangedCallbackReturn
    > = {
    legacyCommand: 'QUERY_GFN_REGISTER_GAMEPAD_CHANGE_CALLBACK',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'RegisterGamepadChangedCallback',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetConnectedGamepads: BridgeCommands.Command<
    {},
    Types.Gfn.Streaming.GetConnectedGamepadsReturn
    > = {
    legacyCommand: 'QUERY_GFN_GET_CONNECTED_GAMEPADS',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetConnectedGamepads',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterGamepadEventCallback: BridgeCommands.Command<
    Types.Gfn.Streaming.RegisterGamepadEventCallbackParameters,
    Types.Gfn.Streaming.RegisterGamepadEventCallbackReturn
    > = {
    legacyCommand: 'QUERY_GFN_REGISTER_GAMEPAD_EVENT_CALLBACK',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'RegisterGamepadEventCallback',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterMicCallback: BridgeCommands.Command<
    {},
    Types.Gfn.Streaming.RegisterMicCallbackReturn
    > = {
    legacyCommand: 'QUERY_GFN_REGISTER_MIC_CALLBACK',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'RegisterMicCallback',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ShouldDefaultEnableMic: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_SHOULD_DEFAULT_ENABLE_MIC',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'ShouldDefaultEnableMic',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetMicState: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_GET_MIC_STATE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetMicState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetMicState: BridgeCommands.Command<
    Types.Gfn.Streaming.SetMicStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_SET_MIC_STATE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetMicState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetKeyboardLayout: BridgeCommands.Command<
    {},
    string
    > = {
    legacyCommand: 'QUERY_GFN_GET_KEYBOARD_LAYOUT',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetKeyboardLayout',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetKeyboardLayout: BridgeCommands.Command<
    Types.Gfn.Streaming.SetKeyboardLayoutParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_SET_KEYBOARD_LAYOUT',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetKeyboardLayout',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ConfigureStreamingSettings: BridgeCommands.Command<
    Types.Gfn.Streaming.ConfigureStreamingSettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_UPDATE_STREAMING_SETTINGS',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'ConfigureStreamingSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SendUnicode: BridgeCommands.Command<
    Types.Gfn.Streaming.SendUnicodeParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_SEND_UNICODE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SendUnicode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OnKBLayoutChange: BridgeCommands.Command<
    {},
    string
    > = {
    legacyCommand: 'QUERY_GFN_REGISTER_ON_KEYBOARD_LAYOUT_CHANGED',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'OnKBLayoutChange',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetUnifiedAPIVersion: BridgeCommands.Command<
    {},
    string
    > = {
    legacyCommand: 'QUERY_GFN_GET_UNIFIED_API_VERSION',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetUnifiedAPIVersion',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OnIMEWindowClosed: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_REGISTER_ON_IME_WINDOW_CLOSED',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'OnIMEWindowClosed',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OnIMEWindowOpened: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_REGISTER_ON_IME_WINDOW_OPENED',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'OnIMEWindowOpened',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDisplayMode: BridgeCommands.Command<
    {},
    Types.Gfn.Streaming.DisplayModeReturn
    > = {
    legacyCommand: 'QUERY_GFN_GET_DISPLAY_MODE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetDisplayMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetVsyncEnabled: BridgeCommands.Command<
    Types.Gfn.Streaming.SetVsyncEnabledParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_SET_VSYNC_ENABLED',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetVsyncEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAdaptiveFramePacingEnabled: BridgeCommands.Command<
    Types.Gfn.Streaming.SetAdaptiveFramePacingEnabledParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_SET_ADAPTIVE_FRAME_PACING_ENABLED',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetAdaptiveFramePacingEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetHudState: BridgeCommands.Command<
    Types.Gfn.Streaming.SetHudStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_SET_HUD_STATE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetHudState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDynamicStreamingModesState: BridgeCommands.Command<
    Types.Gfn.Streaming.SetDynamicStreamingModesStateParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_SET_DYNAMIC_STREAMING_MODE_STATE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetDynamicStreamingModesState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetPreFilterState: BridgeCommands.Command<
    Types.Gfn.Streaming.SetPreFilterStateParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_SET_PRE_FILTER_STATE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetPreFilterState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetStreamingMaxBitrate: BridgeCommands.Command<
    Types.Gfn.Streaming.SetStreamingMaxBitrateParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_SET_STREAMING_MAX_BITRATE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetStreamingMaxBitrate',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetIdleTimeout: BridgeCommands.Command<
    Types.Gfn.Streaming.SetIdleTimeoutParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_SET_IDLE_TIMEOUT',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetIdleTimeout',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const UpdateEventInfoGuids: BridgeCommands.Command<
    Types.Gfn.Streaming.UpdateEventInfoGuidsParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_UPDATE_EVENT_INFO_GUIDS',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'UpdateEventInfoGuids',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterGridServerAnalyticsCallback: BridgeCommands.Command<
    {},
    Types.Gfn.Streaming.RegisterGridServerAnalyticsCallbackReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'RegisterGridServerAnalyticsCallback',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAutoResolution: BridgeCommands.Command<
    Types.Gfn.Streaming.GetAutoResolutionParameters,
    Types.Gfn.Streaming.GetAutoResolutionResult
    > = {
    legacyCommand: 'QUERY_GFN_GET_AUTO_RESOLUTION',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetAutoResolution',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StartStreaming: BridgeCommands.Command<
    Types.Gfn.Streaming.StartStreamingParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_START_STREAMING',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'StartStreaming',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const UpdateEventDataElements: BridgeCommands.Command<
    Types.Gfn.Streaming.UpdateEventDataElementsParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'UpdateEventDataElements',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SendClipboardUpdate: BridgeCommands.Command<
    Types.Gfn.Streaming.SendClipboardUpdateParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_SEND_CLIPBOARD_UPDATE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SendClipboardUpdate',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AuthorizeAVDevices: BridgeCommands.Command<
    Types.Gfn.Streaming.AuthorizeAVDevicesParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_AUTH_AV_DEVICES',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'AuthorizeAVDevices',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PlatformGetMaxBitRateForArray: BridgeCommands.Command<
    Types.Gfn.Streaming.PlatformGetMaxBitRateForArrayParameters,
    Types.Gfn.Streaming.PlatformGetMaxBitRateForArrayReturn
    > = {
    legacyCommand: 'QUERY_GFN_PLATFORM_GET_MAXBITRATE_ARRAY',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'PlatformGetMaxBitRateForArray',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SendKeyEvent: BridgeCommands.Command<
    Types.Gfn.Streaming.SendKeyEventParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_SEND_KEY_EVENT_TO_STREAMER',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SendKeyEvent',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ToggleISSOStats: BridgeCommands.Command<
    Types.Gfn.Streaming.ToggleISSOStatsParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_TOGGLE_ISSO_STATS',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'ToggleISSOStats',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsPlatformSupportsHDRStreaming: BridgeCommands.Command<
    {},
    Types.Gfn.Streaming.IsPlatformSupportsHDRStreamingReturn
    > = {
    legacyCommand: 'QUERY_GFN_IS_PLATFORM_SUPPORTS_HDR_STREAMING',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'IsPlatformSupportsHDRStreaming',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterHDRStreamingStatusNotification: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_REGISTER_HDR_STATUS',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'RegisterHDRStreamingStatusNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StreamingCodecNotification: BridgeCommands.Command<
    {},
    Types.Gfn.Streaming.StreamingCodecNotificationReturn
    > = {
    legacyCommand: 'QUERY_STREAMING_CODEC_NOTIFICATION',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'StreamingCodecNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StreamingL4SStateNotification: BridgeCommands.Command<
    {},
    Types.Gfn.Streaming.StreamingL4SStateNotificationReturn
    > = {
    legacyCommand: 'QUERY_STREAMING_L4S_STATE_NOTIFICATION',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'StreamingL4SStateNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RecordingTranscodeSupport: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_RECORDING_TRANSCODE_SUPPORT',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'RecordingTranscodeSupport',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsPlatformSupportFps: BridgeCommands.Command<
    Types.Gfn.Streaming.IsPlatformSupportFpsParameters,
    Types.Gfn.Streaming.IsPlatformSupportFpsReturn
    > = {
    legacyCommand: 'QUERY_GFN_IS_PLATFORM_SUPPORT_FPS',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'IsPlatformSupportFps',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CalculateDataUsage: BridgeCommands.Command<
    Types.Gfn.Streaming.CalculateDataUsageParameters,
    Types.Gfn.Streaming.CalculateDataUsageReturn
    > = {
    legacyCommand: 'QUERY_GFN_CALCULATE_DATA_USAGE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'CalculateDataUsage',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const UpdateAdState: BridgeCommands.Command<
    Types.Gfn.Streaming.UpdateAdStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_UPDATE_AD_STATE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'UpdateAdState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetPlatformCloudGsyncCapabilities: BridgeCommands.Command<
    {},
    Types.Gfn.Streaming.GetPlatformCloudGsyncCapabilitiesReturn
    > = {
    legacyCommand: 'QUERY_GFN_GET_PLATFORM_CLOUD_GSYNC_CAPABILITIES',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetPlatformCloudGsyncCapabilities',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDeviceCapabilities: BridgeCommands.Command<
    Types.Gfn.Streaming.GetDeviceCapabilitiesParameters,
    string
    > = {
    legacyCommand: 'QUERY_GFN_GET_SERIALIZED_DEVICE_CAPABILITIES',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetDeviceCapabilities',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetStreamingL4sState: BridgeCommands.Command<
    Types.Gfn.Streaming.SetStreamingL4sStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_SET_STREAMING_L4S_STATE',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetStreamingL4sState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PrefetchDeviceCapabilities: BridgeCommands.Command<
    Types.Gfn.Streaming.PrefetchDeviceCapabilitiesParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_GFN_PREFETCH_DEVICE_CAPABILITIES',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'PrefetchDeviceCapabilities',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetClientSupportsVirtualGamepad: BridgeCommands.Command<
    Types.Gfn.Streaming.SetClientSupportsVirtualGamepadParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_SET_CLIENT_SUPPORTS_VIRTUAL_GAMEPAD',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetClientSupportsVirtualGamepad',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGamepadBitmap: BridgeCommands.Command<
    {},
    number
    > = {
    legacyCommand: 'QUERY_GET_GAMEPAD_BITMAP',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'GetGamepadBitmap',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetSupportedHidTypes: BridgeCommands.Command<
    Types.Gfn.Streaming.SetSupportedHidTypesParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_SET_SUPPORTED_HID_TYPES',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetSupportedHidTypes',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetMicRecordingEnabled: BridgeCommands.Command<
    Types.Gfn.Streaming.SetMicRecordingEnabledParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_SET_MIC_RECORDING_ENABLED',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'SetMicRecordingEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OpenLinkInExternalBrowser: BridgeCommands.Command<
    Types.Gfn.Streaming.OpenLinkInExternalBrowserParameters,
    any
    > = {
    legacyCommand: 'QUERY_OPEN_LINK_EXTERNAL_BROWSER',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'OpenLinkInExternalBrowser',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const UpdateVirtualGamepadInput: BridgeCommands.Command<
    Types.Gfn.Streaming.UpdateVirtualGamepadInputParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_UPDATE_VIRTUAL_GAMEPAD_INPUT',
    system: 'CrimsonNative',
    module: 'Streaming',
    method: 'UpdateVirtualGamepadInput',
    persistent: false
};

export const Streaming = {
Start,
Prepare,
SetAuthInfo,
SetAuthToken,
SetPrefetchedSettings,
Stop,
Cleanup,
GetActiveSessions,
GetSessionInfo,
Cancel,
Resume,
PauseStreaming,
UpdateRemoteConfig,
RegisterCallback,
OpenOsr,
CloseOsr,
OsrRegisterCustomKeyPress,
OsrUnregisterCustomKeyPress,
OsrCheckKeyPressCombination,
OsrRegisterKeyPressCallback,
OsrSetOverlayResolution,
GetStreamVolume,
GetStreamStats,
SetStreamVolume,
SetMagnificationFilter,
GetMagnificationFilterSupport,
GetMagnificationFilterSupportList,
SetMagnificationFilterSharpness,
ToggleUserInput,
ToggleJoystickMouse,
SetVirtualKeyboardState,
SetVideoTransforms,
ToggleStats,
RegisterGamepadChangedCallback,
GetConnectedGamepads,
RegisterGamepadEventCallback,
RegisterMicCallback,
ShouldDefaultEnableMic,
GetMicState,
SetMicState,
GetKeyboardLayout,
SetKeyboardLayout,
ConfigureStreamingSettings,
SendUnicode,
OnKBLayoutChange,
GetUnifiedAPIVersion,
OnIMEWindowClosed,
OnIMEWindowOpened,
GetDisplayMode,
SetVsyncEnabled,
SetAdaptiveFramePacingEnabled,
SetHudState,
SetDynamicStreamingModesState,
SetPreFilterState,
SetStreamingMaxBitrate,
SetIdleTimeout,
UpdateEventInfoGuids,
RegisterGridServerAnalyticsCallback,
GetAutoResolution,
StartStreaming,
UpdateEventDataElements,
SendClipboardUpdate,
AuthorizeAVDevices,
PlatformGetMaxBitRateForArray,
SendKeyEvent,
ToggleISSOStats,
IsPlatformSupportsHDRStreaming,
RegisterHDRStreamingStatusNotification,
StreamingCodecNotification,
StreamingL4SStateNotification,
RecordingTranscodeSupport,
IsPlatformSupportFps,
CalculateDataUsage,
UpdateAdState,
GetPlatformCloudGsyncCapabilities,
GetDeviceCapabilities,
SetStreamingL4sState,
PrefetchDeviceCapabilities,
SetClientSupportsVirtualGamepad,
GetGamepadBitmap,
SetSupportedHidTypes,
SetMicRecordingEnabled,
OpenLinkInExternalBrowser,
UpdateVirtualGamepadInput
};
